<template>
  <div id="section-blog" class="section-blog">
    <sm-event
      triggerHook="0.5"
      duration="100%"
      @onEnter="onEnter"
      @onLeave="onLeave"
      :offset="0"
      durationType="element"
      ref="smEvent"
    ></sm-event>
    <div class="section">
      <div id="title-blog" class="row">
        <div class="section-title">THOUGHT</div>
      </div>
    </div>
    <div class="blogs">
      <div class="blogs-wrapper">
        <div class="blogs-title">
          <p>日々考えるデザインのあれやこれを<br>雑多な記事にしています。</p>
        </div>
        <transition-group class="blog-list" name="blogs" tag="ul" ref="blogList">
          <li class="col-6 col-md-4 col-mdlg-3" v-for="(item, index) in blogs" :key="index">
            <a @click="clickLink(item.id)">
              <img :src="item.featuredimage" :alt="item.title">
              <b>{{ item.title }}</b>
              <p>{{ htmlToNode(item.excerpt) }}</p>
            </a>
          </li>
        </transition-group>
      </div>
      <button v-show="isMoreBlog" @click="injectBlogs">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98.08 14.84"><path d="M0 .28h2.42l2.42 11.4L7.4.28h2.42l-3.6 14.28h-2.9L0 .28zm12.03 0h2.28v14.28h-2.28V.28zm6.04 0h7.72V2.2h-5.44v4h5.12v1.92h-5.12v4.55h5.57v1.92h-7.88L18.07.28zm9.56 0h2.29l1.89 11.1L33.69.28h2.4l1.92 11.16L39.87.28h2.26l-2.84 14.28h-2.64L34.92 3.8 33.1 14.56h-2.65L27.63.28zm22.7 0h3.59l2.52 10.58L58.92.28h3.48v14.28h-2.16V2.67l-2.88 11.88h-1.92L52.53 2.67v11.88h-2.16L50.33.28zm15.3 7.14c0-5.1 1.44-7.42 4.72-7.42s4.72 2.32 4.72 7.42-1.44 7.42-4.72 7.42-4.72-2.32-4.72-7.42zm7.16-.06c0-4.8-1.08-5.64-2.44-5.64s-2.44.84-2.44 5.64 1.08 5.76 2.44 5.76 2.44-.84 2.44-5.76zM78.3.28h5c2 0 3.62 1 3.62 3.68 0 1.84-.82 3.26-2.38 3.5 1.42.14 2.16.92 2.24 2.92 0 .92 0 2 .08 2.9 0 .5.26.97.68 1.24h-2.58c-.24-.38-.37-.81-.38-1.26-.08-.86-.06-1.66-.1-2.7 0-1.56-.52-2.24-2.08-2.24h-1.86v6.2h-2.28L78.3.28zm4.1 6.36a2.09 2.09 0 002.28-1.9c.01-.14.01-.28 0-.42 0-1.52-.66-2.32-2.16-2.32h-1.94v4.67l1.82-.03zM90.24.28h7.68V2.2h-5.44v4h5.12v1.92h-5.12v4.55h5.6v1.92H90.2L90.24.28z" fill="#818181"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import { shuffleArray } from '../bin/helpers'

export default {
  data () {
    return {
      blogs: [],
      shuffledBlogs: [],
      isMoreBlog: true,
      BlogsNumber: null
    }
  },
  props: {
    data: Array
  },
  methods: {
    zeroFill (num) {
      const numArray = num.toString().split('')
      if (numArray.length === 1) {
        numArray.unshift('0')
      }
      return numArray.join('')
    },
    onEnter (event) {
      document.body.classList.add('thought-white')
      // if (event.scrollDirection === 'FORWARD') {
      //   document.getElementsByClassName('c-mainmenu')[0].classList.add('hide')
      // }
    },
    onLeave (event) {
      // document.body.classList.remove('thought-white')
      if (event.scrollDirection === 'REVERSE') {
        document.body.classList.remove('thought-white')
        // document.getElementsByClassName('c-mainmenu')[0].classList.remove('hide')
      }
    },
    injectBlogs (initFlg) {
      if (this.data === undefined) return // the data won't catch up at the begining
      const self = this
      const number = this.getBlogsNumber()
      const currentAmount = (initFlg === true) ? 0 : document.querySelectorAll('.blog-list li').length
      const blogData = (this.$route.name !== 'home') ? this.shuffledBlogs : this.data
      const totalBlogs = blogData.length
      let loadAmount = 0
      let sequenseNumber = 0
      if ((number + currentAmount) >= totalBlogs) {
        loadAmount = totalBlogs
        this.isMoreBlog = false
      } else {
        loadAmount = number + currentAmount
      }
      if (currentAmount >= totalBlogs) {
        return false
      }
      for (let index = currentAmount; index < loadAmount; index++) {
        setTimeout(function () {
          self.blogs.push(blogData[index])
          self.$refs.smEvent.handleResize() // this resize calls as many as posts are loaded
        }, sequenseNumber * 200)
        sequenseNumber++
      }
    },
    htmlToNode (htmlStr) {
      if (!htmlStr || typeof htmlStr !== 'string') return

      const tmpElement = document.createElement('div')
      tmpElement.innerHTML = htmlStr
      return tmpElement.innerText
    },
    clickLink (id) {
      if (this.$route.name === 'media') {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      }
      this.$router.push('/thought/' + id)
    },
    getBlogsNumber () {
      let blogAmount =
        (this.$router.currentRoute.path === '/')
          ? this.$store.state.minPostsForNotTablet
          : this.$store.state.minPostsForNotTabletBlog
      if (this.$store.state.currentMq === 'query-md') {
        blogAmount =
          (this.$router.currentRoute.path === '/')
            ? this.$store.state.minPostsForTablet
            : this.$store.state.minPostsForTabletBlog
      }
      return blogAmount
    }
  },
  mounted () {
    if (this.data === undefined) return
    this.shuffledBlogs = shuffleArray(this.data)
    this.injectBlogs(true)
  },
  watch: {
    data: function (newVal, oldVal) {
      this.shuffledBlogs = shuffleArray(this.data)
      if (newVal === undefined) return
      this.injectBlogs()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SectionBlog.vue